<template>
    <div class="flat-view">
        <amf-form :title="title" class="container-fluid">
            <div class="row" v-if="!isEmployer && !isParticipant">
                <amf-select caption="--Select Issue Type--" :options="issueTypes" v-model="selectedType"
                    v-on:input="filterIssues" />
            </div>

            <v-client-table v-if="!busy && filteredIssues.length" :data="filteredIssues" :columns="columns"
                :options="tableOptions" ref="issuestable">
                <template v-slot:name="{ row }">
                    <div>
                        <span class="entity-type">
                            <span v-if="row.entityType == 'Employer'">
                                <i class="fa fa-building entity-type" />
                                <router-link :to="`/employer/` + row.employerId + `/general`">
                                    {{ row.name }}
                                </router-link>
                            </span>
                            <span v-if="row.entityType == 'Account'">
                                <i class="fa fa-calendar" />
                                <router-link :to="`/participant/` + row.participantId + `/accounts`">
                                    {{ row.name }}
                                </router-link>
                                ({{ row.employerName }})
                            </span>
                            <span v-if="row.entityType == 'Participant'">
                                <i class="fa fa-user" />
                                <router-link :to="`/participant/` + row.entityGuid + `/general`">
                                    {{ row.name }}
                                </router-link>
                                ({{ row.employerName }})
                            </span>
                        </span>
                    </div>
                </template>
                <template v-slot:employerName="{ row }">
                    <div>
                        <router-link :to="`/employer/` + row.employerId + `/general`">
                            {{ row.employerName }}
                        </router-link>
                    </div>
                </template>
                <template v-slot:description="{ row }">
                    <div title="Description">
                        <span v-html="row.description"></span>
                    </div>
                </template>
                <template v-slot:notes="{ row }">
                    <div :title="row.notes">
                        {{ row.notes && row.notes.length > 15 ? (row.notes.slice(0, 15) + '...') : row.notes }}
                    </div>
                </template>
                <template v-slot:actions="{ row }">
                    <div>
                        <a class="filter" style="float: right;" @click="toggleNote(row)">
                            <i v-if="opended.includes(row.issueId)" class="fa fa-chevron-up"
                                title="Close Issue Details" />
                            <i v-else class="fa fa-chevron-down" title="View/Edit Issue Details" />
                        </a>
                    </div>
                </template>
                <template v-slot:child_row="{ row }">
                    <div>
                        <div class="row issue-list">
                            <div class="col-6">
                                <ul>
                                    <li v-for="col in columnNames" :key="col.id">
                                        <div v-if="col.id != 'notes'">
                                            <label>{{ col.name }}:</label> {{ row[col.id] }}
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <div class="col-6">
                                <label class="mb-0 ml-2">Notes:</label>
                                <amf-textarea v-model="row.notes" label="Notes" :show-label="false" :columns="3"
                                    :rows="3"></amf-textarea>
                                <amf-button class="btn-default mr-2" style="float: right;"
                                    :onClick="function () { toggleNote(row) }">Close</amf-button>
                                <amf-button class="btn-success mr-2" style="float: right;"
                                    :onClick="function () { saveNote(row) }">Save</amf-button>
                                <amf-button class="btn-default mr-4" style="float: right;"
                                    :onClick="function () { deleteIssue(row) }">Delete</amf-button>
                                <amf-button class="btn-default mr-2" style="float: right;"
                                    :onClick="function () { suppressIssue(row) }">Suppress</amf-button>
                            </div>
                        </div>
                    </div>
                </template>
            </v-client-table>
            <div v-else-if="!filteredIssues.length" style="text-align: center;">
                No matching records
            </div>
        </amf-form>
    </div>
</template>

<script>
import { modalService } from '../framework/utils/modal-service';

export default {
    routeQuery: ["category", "issueType"],
    data() {
        return {
            amfOptions: { noTracking: true },
            busy: false,
            issues: [],
            issueTypes: [],
            selectedType: null,
            filteredIssues: [],
            filters: [],
            category: null,
            issueType: null,
            opended: [],
            tableOptions: {
                ...utils.getVueTablesOptions(),
                pagination: {
                    chunk: 1000,
                    dropdown: false
                },
                perPageValues: [],
                perPage: 100,
                texts: {
                    filter: null,
                    count: ''
                },
                uniqueKey: "issueId",
                showChildRowToggler: false,
                headings: {
                    name: "Name",
                    employerName: "Employer Name",
                    amfCode: "AMF Code",
                    employees: "Employees",
                    createdDate: "Created",
                    category: "Category",
                    issueType: "Issue Type",
                    description: "Description",
                    notes: "Notes",
                    actions: "",
                },
                hiddenColumns: [
                    "employerName",
                    "employees"
                ],
                columnsClasses:{
                    'amfCode': 'vt-1', 
                    'createdDate': 'vt-1',
                    'actions': 'vt-2',                
                    'employees': 'vt-1'
                },
                sortable: [
                    "name",
                    "employerName",
                    "createdDate",
                    "amfCode",
                    "employees",
                    'category',
                    'issueType',
                ],
                orderBy: { column: 'createdDate', ascending: false },
                customSorting: {
                    createdDate: function (ascending) {
                        return function (a, b) {
                            var dateA = moment(a.createdDate, 'MM-DD-YYYY');
                            var dateB = moment(b.createdDate, 'MM-DD-YYYY');

                            return ascending ? dateA.diff(dateB) : dateB.diff(dateA);
                        }
                    }
                }
            }
        };
    },
    computed: {
        ...amfx.map("participant", "participantId"),
        ...amfx.map("employer", "employerId"),
        title() {
            return "Pending Issues (" + this.filteredIssues.length + ")";
        },
        columns() {
            return Object.keys(this.tableOptions.headings)
        },
        columnNames() {
            return Object.entries(this.tableOptions.headings)
                .map(x =>{ return { id: x[0], name: x[1] }})
                .filter(y => y.name);
        },
        isEmployer() {
            return this.$route.path.includes("/employer/");
        },
        isParticipant() {
            return this.$route.path.includes("/participant/");
        }
    },
    methods: {      
        async loadIssues() {
            let issues = null;
            if (this.isEmployer) {
                if (this.employerId) issues = await romeApi.get(`employer/${this.employerId}/issue`);
            } else if (this.isParticipant) {
                if (this.participantId) issues = await romeApi.get(`participant/${this.participantId}/issue`);
            } else {
                issues = await romeApi.get(`issue`);
            }

            var types = issues.map(t => { return { id: t.issueType, categoryId: t.category } });
            var groupedByCategory = _.groupBy(types, 'categoryId');

            var issueTypes = _.flatMap(groupedByCategory, (items, categoryId) => {
                var result = [];
                
                if(items.length > 1) {
                    result.push({ id: getUniqueName('all'), name: getUniqueName('all'), categoryId, issueType: null })
                }
                
                result.push(...items.map(item => ({ id: getUniqueName(item.id), name: getUniqueName(item.id), categoryId, issueType: item.id })));
                return result;

                function getUniqueName(name) {
                    return `${categoryId}: ${name}`
                }
            });

            this.issueTypes = _.uniqBy(issueTypes, 'id');

            this.setColumnVisibility("employees", !this.isEmployer && !this.isParticipant);
            if (!issues) return;
            this.formatIssues(issues);
            this.issues = issues;
            this.filteredIssues = issues;
            this.filterIssues();
        },
        formatIssues(issues) {
            issues.forEach(x => {
                x.createdDate = moment(x.createdDate).format("L");
                x.employees = x.activeParticipants;
                x.description = x.description.replace(/\n/g, '<br/>');
            });
        },
        setCategoryAndType() {
            if(!this.selectedType) {
                this.category = null;
                this.issueType = null;
                return;
            }

            var issueType = this.issueTypes.find(i => i.id == this.selectedType);
            this.category = issueType.categoryId;
            this.issueType = issueType.issueType;
        },
        filterIssues() {
            this.busy = true;
            this.setCategoryAndType();
            
            this.filteredIssues = this.issues.filter(i => {
                if(this.category && !i.category.includes(this.category)) return false;
                if(this.issueType && !i.issueType.includes(this.issueType)) return false;

                return true;
            });

            this.busy = false;
        },
        setColumnVisibility(colName, visible) {
            if (visible) {
                _.remove(this.tableOptions.hiddenColumns, c => c == colName);
            }
            else if (!this.tableOptions.hiddenColumns.includes(colName)) {
                this.tableOptions.hiddenColumns.push(colName)
            }
        },
        toggleNote(row) {
            let index = this.opended.indexOf(row.issueId);
            if(index > -1) this.opended.splice(index, 1);
            else this.opended.push(row.issueId);
            this.$refs.issuestable.toggleChildRow(row.issueId);
        },
        async saveNote(row) {
            await romeApi.post(`issue/${row.issueId}`, { notes: row.notes });
            this.$refs.issuestable.data
                .forEach(x => { if(x.issueId == row.issueId) x.notes = row.notes });
            toastService.success("Notes Updated");
            this.toggleNote(row);
        },
        hideRow(row) {
            this.toggleNote(row);
            let index = this.issues.findIndex(x => { return x.issueId == row.issueId});
            this.issues.splice(index, 1);
            this.filterIssues();
        },
        async deleteIssue(row) {
            if (await modalService.confirm("Are you sure you want to delete this pending issue?")) {
                await romeApi.delete(`issue/${row.issueId}`);
                this.hideRow(row);
                toastService.success("Issue Deleted");
            }
        },
        async suppressIssue(row) {
            if (await modalService.confirm("Suppressed issues will not show again even if the underlying problem still exists. Are you sure?")) {
                await romeApi.post(`issue/${row.issueId}/suppress`);
                this.hideRow(row);
                toastService.success("Issue is suppressed and will not show again.");
            }
        }
    },
    created() {
        this.loadIssues();
    }
}
</script>

<style lang="scss" scoped>
.entity-type .fa {
    margin-right: 0.5rem;
}
.filter {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
    cursor: pointer;
}
.issue-list ul {
    margin-bottom: 0;
    padding-left: 0;
    list-style-type: none;
}
.issue-list label {
    margin-right: 0.5rem;
    font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/shared/PendingIssues.vue